var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("closing-analysis", {
    attrs: {
      "complete-replacement": _vm.completeReplacement,
      "delete-compensatory-document": _vm.deleteCompensatoryDocument,
      "download-document-by-attachment-id": _vm.downloadDocumentByAttachmentId,
      "get-compensatory-approvement-reasons":
        _vm.getCompensatoryApprovementReasons,
      "get-compensatory-document-types": _vm.getCompensatoryDocumentTypes,
      "get-compensatory-request-analysis-data":
        _vm.getCompensatoryRequestAnalysisData,
      "get-compensatory-request-replacement-comments-strategies":
        _vm.getCompensatoryRequestReplacementCommentsStrategies,
      "get-compensatory-request-replacement-strategies":
        _vm.getCompensatoryRequestReplacementStrategies,
      "get-sys-parameter": _vm.getSysParameter,
      "has-permissions": _vm.hasPermissions,
      "replacement-document-upload": _vm.replacementDocumentUpload,
      "reset-replacement": _vm.resetReplacement,
      "submit-closing-analysis": _vm.submitClosingAnalysis,
      "update-compensatory-service-balance":
        _vm.updateCompensatoryServiceBalance
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }